import { connect } from "react-redux";
import { Selectors } from "@/store/clientProfile/selectors";

import SEO from "./seo";
const mSp = state => ({
  avatar: Selectors.getAvatar(state),
  name: Selectors.getFullName(state),
  sex: Selectors.getSex(state)
});
export default connect(mSp)(SEO);
